<template>
  <div>
    <ul :class="[$style.list, 'hide-on-print']">
      <UbsMunicipalityGuide
        v-if="listing.address && listing.offerType && isListingValidForUbsGuide(listing)"
        :address="listing.address"
        :offerType="listing.offerType"
        @trackPartnerLink="trackPartnerLinkFunction"
      >
      </UbsMunicipalityGuide>

      <ILocator v-if="isIlocatorVisible" @trackPartnerLink="trackPartnerLinkFunction"> </ILocator>

      <Movu @trackPartnerLink="trackPartnerLinkFunction"></Movu>
    </ul>
  </div>
</template>

<script lang="ts" setup>
import { Listing, OfferType } from '@smg-real-estate/hg-rets-schema';
import { computed } from 'vue';

import { isListingValidForUbsGuide } from '@/components/PartnerIntegrations';
import ILocator from '@/components/PartnerIntegrations/ILocator/ILocator.vue';
import Movu from '@/components/PartnerIntegrations/Movu/Movu.vue';
import UbsMunicipalityGuide from '@/components/PartnerIntegrations/UbsMunicipalityGuide/UbsMunicipalityGuide.vue';
import { InteractionGoal } from '@/helpers/GTM/GTMParameters';
import { isPlatformHg } from '@/helpers/platformDetection';

import { trackPartnerLink } from '../functions/tracking';

defineOptions({
  name: 'PartnerListAvailability',
});

interface Props {
  listing: Listing;
}
const props = defineProps<Props>();

const isIlocatorVisible = computed((): boolean => {
  return isPlatformHg() && props.listing.offerType === OfferType.Rent;
});
const trackPartnerLinkFunction = (externalUrl: string, interactionGoal: InteractionGoal): void => {
  trackPartnerLink(externalUrl, interactionGoal, props.listing.id);
};
</script>

<style lang="scss" module>
@import '@/assets/variables';

.list {
  display: flex;
  flex-direction: column;
  gap: $space-75;
  justify-content: space-between;
  padding: 0;
  margin: $space-150 0;
  list-style: none;
}
</style>
